import { useHistory } from 'react-router';
import { Typography } from '@shinetools/sunshine-universal';

import { ShineRecurringAccountingExportSettings } from '__generated__/GQL';
import IconButton from 'components/_core/IconButton';
import SunshineCard from 'components/_core/SunshineCard';
import { formatDate } from 'helpers/date';

import * as routes from '../../../../../../routes';
import locales from './locales';

type ItemProps = Pick<
  ShineRecurringAccountingExportSettings,
  'accountingExportSettingsId' | 'nextExportAt'
>;

export const Item = ({
  accountingExportSettingsId,
  nextExportAt,
}: ItemProps) => {
  const history = useHistory();
  const formattedNextExportAt = new Date(nextExportAt);

  return (
    <SunshineCard
      alignItems="center"
      title={locales.formatString(locales.title, {
        date: formatDate(formattedNextExportAt, 'LLLL yyyy'),
      })}
    >
      <Typography.Text size="small" variant="secondary">
        {locales.formatString(locales.nextExportAt, {
          date: formatDate(formattedNextExportAt, 'PPP'),
        })}
      </Typography.Text>

      <SunshineCard.Slot name="action">
        <IconButton
          aria-label=""
          icon="vertical-ellipsis"
          onClick={() =>
            history.push(routes.getExportPath(accountingExportSettingsId))
          }
          variant="secondary"
        />
      </SunshineCard.Slot>
    </SunshineCard>
  );
};
